class IntegrationLogController extends AbstractController
	@register()
	@inject 'IntegrationLogRepository',
		'IntegrationFileRepository'
		'translate'
		'$state'
		'BACKEND_INTEGRATION_LOG_STATUS'
		'BACKEND_API_ENDPOINT'
		'SEARCH_CONFIGURATION'

	##
	# As of 2026-08 we do not allow initial search of all integrations logs,
	# because SJ Trains having more then 30% logs in table and it prevents MySql from using inefficient index
	##
	initialize: ->
		@logs = []

		# Routes can set data.fixedIntegrationId (e.g. integration_logs_gbat10) to scope this page to one integration
		@fixedIntegrationId = @$state.current.data?.fixedIntegrationId ? null

		@filterDTO = new FilterDTO({
			searchConfiguration: @SEARCH_CONFIGURATION.integration_log
			itemsCount: 0
		})

		@doInitialSearch = false

		if @fixedIntegrationId
			# Integration is fixed for this page, so the picker is not needed
			delete @filterDTO.searchConfiguration.integration_id
			@doInitialSearch = true

	search: ->
		query = @filterDTO.getQuery()
		query.sortBy('id', 'DESC')
		query.with 'integration_errors', 'integration_files'

		if @fixedIntegrationId
			query.criteria 'integration_id', '=', @fixedIntegrationId

		@IntegrationLogRepository
			.getEntities query
			.then (logs) =>
				@logs = logs
				@filterDTO.itemsCount = @logs.length

				for log in @logs
					for file in log.integration_files
						file.name = file.path.split('/').pop()

	downloadFile: (file) ->
		@IntegrationFileRepository.download(file.id)

	getAdvancedSearchValues: (filterKey) ->
		if filterKey == 'entity'
			endpoints = []

			for endpoint, entity of @BACKEND_API_ENDPOINT
				endpoints.push({
					id: endpoint,
					name: entity,
				})

			return @IntegrationLogRepository.resolve(endpoints)

		if filterKey == 'status'
			statuses = []

			for status of @BACKEND_INTEGRATION_LOG_STATUS
				statuses.push({
					id: status,
					name: @translate('general.integration_log.status.' + status.toLowerCase())
				})

			return @IntegrationLogRepository.resolve(statuses)
